import * as R from 'ramda'

import { Score } from 'components/KPICard'

export const getScoreComponents = (score: Score) =>
  R.equals(score, Score.Excellent)
    ? {
        statusIndicator: 'success',
        badgeVariant: 'success',
        badgeText: 'Excellent',
      }
    : R.equals(score, Score.Good)
    ? {
        statusIndicator: 'pending',
        badgeVariant: 'pending',
        badgeText: 'Good',
      }
    : R.equals(score, Score.Fair)
    ? {
        statusIndicator: 'warning',
        badgeVariant: 'warning',
        badgeText: 'Fair',
      }
    : R.equals(score, Score.NeedsWork)
    ? {
        statusIndicator: 'danger',
        badgeVariant: 'error',
        badgeText: 'Needs work',
      }
    : {
        statusIndicator: 'none',
        badgeVariant: null,
        badgeText: null,
      }
